export type AuthCallbackCompletionState = {
  error?: unknown;
  isAuthenticated: boolean;
  isLoading: boolean;
};

export const shouldCompleteAuthCallback = (
  state: AuthCallbackCompletionState,
) => state.isAuthenticated && !state.isLoading && !state.error;
